var map = {
	"./components/email-confirmation-message/email-confirmation-message.lang.json": 115,
	"./components/footer/footer.lang.json": 437,
	"./components/pages/survey-pages.lang.json": 146,
	"./components/status-pages/status-pages.lang.json": 965,
	"./components/survey-page/survey-page.lang.json": 97
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 803;